const config = {
  dev: {
    backend: 'http://localhost:8000',
    frontend: 'http://localhost:8081/#/'
  },
  production: {
    backend: 'http://suan.sgidi.top',
    frontend: 'http://localhost:8081/#/'
  }

}

export default config.production
